import { Navigate, useParams } from 'react-router-dom';
import { IndustryPreviewVisual, INDUSTRIES } from '@/modules/marketing/components/industry-visuals';
import { MarketingDetailPage } from '@/modules/marketing/components/marketing-detail-page';

export function IndustryDetailPage() {
    const { slug } = useParams<{ slug: string }>();
    const industry = INDUSTRIES.find((i) => i.slug === slug);

    if (!industry) {
        return <Navigate to="/" replace />;
    }

    return (
        <MarketingDetailPage
            backLabel="Industries"
            backHref="/#products"
            visual={<IndustryPreviewVisual icon={industry.icon} size="lg" />}
            content={{
                eyebrow: 'Industry',
                icon: industry.icon,
                gradient: 'from-[#1e3a5f] to-[#2563eb]',
                title: industry.name,
                tagline: industry.tagline,
                description: industry.description,
                bullets: industry.bullets,
                keywords: `${industry.name} AI chatbot, ${industry.name} pricing software, ${industry.name} lead capture, ${industry.name} CRM, AI assistant for ${industry.name.toLowerCase()}`,
            }}
        />
    );
}
